var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoEqualizer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3433_57412)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 15C7.125 15 7.5 14.625 7.5 14.1667V5.83335C7.5 5.37502 7.125 5.00002 6.66667 5.00002C6.20833 5.00002 5.83333 5.37502 5.83333 5.83335V14.1667C5.83333 14.625 6.20833 15 6.66667 15ZM10 18.3334C10.4583 18.3334 10.8333 17.9584 10.8333 17.5V2.50002C10.8333 2.04169 10.4583 1.66669 10 1.66669C9.54167 1.66669 9.16667 2.04169 9.16667 2.50002V17.5C9.16667 17.9584 9.54167 18.3334 10 18.3334ZM3.33333 11.6667C3.79167 11.6667 4.16667 11.2917 4.16667 10.8334V9.16669C4.16667 8.70835 3.79167 8.33335 3.33333 8.33335C2.875 8.33335 2.5 8.70835 2.5 9.16669V10.8334C2.5 11.2917 2.875 11.6667 3.33333 11.6667ZM13.3333 15C13.7917 15 14.1667 14.625 14.1667 14.1667V5.83335C14.1667 5.37502 13.7917 5.00002 13.3333 5.00002C12.875 5.00002 12.5 5.37502 12.5 5.83335V14.1667C12.5 14.625 12.875 15 13.3333 15ZM15.8333 9.16669V10.8334C15.8333 11.2917 16.2083 11.6667 16.6667 11.6667C17.125 11.6667 17.5 11.2917 17.5 10.8334V9.16669C17.5 8.70835 17.125 8.33335 16.6667 8.33335C16.2083 8.33335 15.8333 8.70835 15.8333 9.16669Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3433_57412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEqualizer);
export default __webpack_public_path__ + "static/media/ico-equalizer.ef4ac58d3e2ab09ceec0e870cce0ab8a.svg";
export { ForwardRef as ReactComponent };